import './suggestion.style.sass';
import template from './suggestion.tpl.pug';

class SuggestionController {
    /* @ngInject */
    constructor($state) {
        this.$state = $state;
        this.features = [
            {
                id: 'calendar',
                title: 'Smart calendar',
                description: 'Track your finances in a familiar calendar view',
                icon: 'calendar'
            },
            {
                id: 'quick-entry',
                title: 'Quick entry',
                description: 'Add expenses with a few taps and have our AI automatically categorize them',
                icon: 'note-add'
            },
            {
                id: 'collaborate',
                title: 'Collaborate with your partner',
                description: 'Track expenses in a shared calendar',
                icon: 'users'
            },
            {
                id: 'multiplatform',
                title: 'Multiplatform',
                description: 'Use your phone to add expenses and your computer when planning',
                icon: 'devices'
            }
        ];
    }

    continueToRegister() {
        this.onSubmit({ questionKey: 'features_shown', answer: true });
        this.$state.go('conversion-quiz.register');
    }
}

export default {
    template: template(),
    controller: SuggestionController,
    bindings: {
        onSubmit: '&'
    }
};



// WEBPACK FOOTER //
// ./src/presentation/scene/conversion-quiz/steps/suggestion/suggestion.cmpt.js